import React from "react";
import { useLanguage } from "../../../../contexts";
import { P, useEnergia } from "../engine";
import { ConInstalacion, Notice, StatusBadge } from "../common/SectionCommon";
import "../common/common.scss";
import "./DenimCycleView.scss";

const fmt = (v, d = 0) => P.fmt(v, d);

// Ciclo completo del denim: solo para plantas con sector «textil – denim» o que lo declaran (hoja 13; hoja 01 filas 15, 48, 138).
// Sin pesos «típicos» por etapa: cada etapa se lee con los datos de ESTA planta.
export function DenimCycleView({ installation }) {
  const { translations } = useLanguage();
  const t = (key) => translations[key] || key;
  const vista = useEnergia(installation);
  return (
    <ConInstalacion installation={installation} vista={vista} t={t}>
      {(f) => {
        if (!P.esDenim(f)) return <Notice tipo="info">{t("energy_performance_denim_not_applicable")}</Notice>;
        const est = P.denimEstado(f);
        const cub = est.filter((x) => x.enScope);
        const top = [...cub].sort((a, b) => b.kwh - a.kwh)[0];
        return (
          <div className="ep-screen">
            <h3 className="ep-screen__title">{t("energy_performance_denim_title")}</h3>
            <div className="ep-kpis">
              <div className="ep-kpi"><div className="ep-kpi__label">{t("energy_performance_denim_covered")}</div><div className="ep-kpi__value">{cub.length}</div></div>
              <div className="ep-kpi"><div className="ep-kpi__label">{t("energy_performance_denim_share")}</div><div className="ep-kpi__value">{fmt(cub.reduce((a, x) => a + x.share, 0), 0)}%</div></div>
              <div className="ep-kpi"><div className="ep-kpi__label">{t("energy_performance_denim_other_links")}</div><div className="ep-kpi__value">{est.length - cub.length}</div></div>
              <div className="ep-kpi"><div className="ep-kpi__label">{t("energy_performance_denim_top")}</div><div className="ep-kpi__value ep-kpi__value--text">{top ? top.e.etapa : "—"}</div>{top && <div className="ep-kpi__sub">{fmt(top.kwh)} kWh · {fmt(top.share, 1)}%</div>}</div>
            </div>
            {est.map((x) => (
              <div key={x.e.n} className={`ep-denim__stage ${x.enScope ? "" : "ep-denim__stage--out"}`}>
                <div className="ep-denim__main">
                  <div className="ep-section__note">{t("energy_performance_denim_stage")} {x.e.n} · {x.e.tipoFEM}</div>
                  <h4>{x.e.etapa}</h4>
                  <p>{x.e.clave}</p>
                  {x.enScope && <p className="ep-denim__reading"><strong>{t("energy_performance_denim_how")}:</strong> {x.lectura}</p>}
                  <p className="ep-section__note"><strong>{t("energy_performance_med_measure")}:</strong> {x.e.medir}</p>
                  <p className="ep-section__note ep-denim__risk"><strong>{t("energy_performance_denim_risk")}:</strong> {x.e.riesgo}</p>
                  {x.ecms.length > 0 && <p className="ep-section__note">{t("energy_performance_denim_measures").replace("{n}", x.ecms.length).replace("{kwh}", fmt(x.ecmKwh)).replace("{i}", x.ecmImpl)}: {x.ecms.map((m) => m.name).join("; ")}</p>}
                </div>
                <div className="ep-denim__side">
                  <StatusBadge estado={P.LBL_VIS[x.estado] || x.estado} />
                  {x.enScope ? <div className="ep-kpi__value">{fmt(x.share, 1)}%<div className="ep-kpi__sub">{fmt(x.kwh)} kWh/{t("energy_performance_year")}</div></div> : <div className="ep-section__note">{t("energy_performance_denim_other_link")}</div>}
                </div>
              </div>
            ))}
          </div>
        );
      }}
    </ConInstalacion>
  );
}
